export default {
    setConnectedPages(state, payload) {
        state.connectedFacebookPages = payload;
    },
    setConnectedWalls(state, payload) {
        state.connectedFacebookWalls = payload;
    },
    setClientDetails(state, payload) {
        state.authUrl = payload;
    },
    setRetrivedPages(state,payload){
        state.retrievedFacebookPages = payload;
    }
}